import { LinkButtonFunction, LinkTarget } from './J3TypeList';
import { J3PanelBase } from './J3PanelBase';

export class J3SideLinkPanel extends J3PanelBase {
    linkDiv: HTMLElement;

    constructor(debugLvl = 0, name='', enable = true, visible = true, targetID: string, imageFile: string, public fn: LinkButtonFunction, public url: string, public linkTarget:LinkTarget, css = {}, useAtag: boolean = false) {
        super();
        //if(fn == 'back') this.linkTarget = '_blank'; //呼び出し元URLに戻る際は '_blank'にする
        this.name = name;
        const elem = document.querySelector('#' + targetID) as HTMLElement;

        if (elem) {
            if (enable) {
                //HTML構造
                //<div id="sidenav" class="side_nav">
                //    <div class="exit">
                //        <figure>
                //            <button type="button" id="###">
                //                <a href="index.html" target="_self">
                //                    <img src="img/top_button.png" alt="">
                //                </a>
                //            </button>
                //        </figure>
                //    </div>
                //</div>
                this.linkDiv = document.createElement('div');
                //CSSの適用
                console.log('J3SideLinkPanel CSS:',css['class'],css['bottom'],css['right']);
                if(css['class']) this.linkDiv.classList.add(css['class']);
                if (css['bottom']) this.linkDiv.style.bottom = css['bottom'];
                if (css['right']) this.linkDiv.style.right = css['right'];

                const figure = document.createElement('figure');
                const button = document.createElement('button');
                button.type = 'button';
                const img = document.createElement('img');
                img.src = imageFile;

                if (useAtag) {
                    const a = document.createElement('a');
                    a.href = url;
                    a.target = '_self';
                    a.appendChild(img);
                    button.appendChild(a);
                } else {
                    button.appendChild(img);
                    button.addEventListener("click", (e: Event) => { this.Clicked(e) });
                }
                figure.appendChild(button);
                this.linkDiv.appendChild(figure);
                elem.appendChild(this.linkDiv);
                this.Show();

                if (visible){
                    this.ShowButton(this.linkDiv);
                }else{
                    this.HideButton(this.linkDiv);
                }
            } else {
                elem.style.display = 'None';
            }
        }
    }

    Clicked(e: Event) {
        const ref = document.referrer;
        console.log('document.referrer', ref);

        if (this.fn == 'url') {
            //指定したURLへ
            if (this.linkTarget == '_self') {
                window.location.href = this.url;
            } else {
                window.open(this.url);
            }
        } else if (this.fn == 'back') {
            //直前のタブに戻る
            console.log(window.history.back());
            window.history.back();
        }
    }

    DummyMethod() {
        console.log('J3SideLinkPanel');
    }

    Hide() {
        this.linkDiv.style.display = 'none';
    }
    Show() {
        this.linkDiv.style.display = 'block';
    }

}